export const handleChangeDataTransferPage = (name, value) => ({
    type: 'CHANGE_DATA_PAGE_TRANSFER', name, value
});